import React, { Fragment } from 'react';
import { Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { trackActivity } from '../../utils/mixpanel';
import { checkPermission, getLocalStorageInfo } from '../../utils';
import config from '../../config'
const AssetAddDropdown = ({toggleAssetType}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event, assetType) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    if(assetType){
      toggleAssetType(assetType)
    }
  };

  function handleListKeyDown(event) {

    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  const hideModuleForAvolon =  getLocalStorageInfo()?.defaultLessor?.id === 470 
  const hideModuleForSmbc = getLocalStorageInfo()?.defaultLessor?.id === (config.env.key === "api" ? 465 : 532 )
  return(
    <Fragment>
      <Button
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        color="primary"
        variant="contained"
        size="small"
      >
        Add Asset <ArrowDropDownIcon />
      </Button>
      <Popper placement="bottom-end" style={{zIndex: '9'}} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  {checkPermission('technical_specs', 'aircraft','C')  && !hideModuleForSmbc ? 
                    <MenuItem onClick={(event) => { handleClose(event,'Aircraft'); trackActivity('Item Clicked',{page_title:'Asset List', item_type:'Add Aircraft', event_desc:'Clicked on Aircraft from Add Asset in Asset listing page'})}}>Aircraft &ensp; &ensp; &ensp;</MenuItem>:null
                  }
                  { checkPermission('technical_specs', 'engine','C') ? 
                    <MenuItem style={{width:'120px',height:"20px"}} onClick={(event) => { handleClose(event,'Engine'); trackActivity('Item Clicked',{page_title:'Asset List', item_type:'Add Engine', event_desc:'Clicked on Engine from Add Asset in Asset listing page'})}}>Engine</MenuItem>:null
                  }
                  { checkPermission('technical_specs', 'apu','C')  && !hideModuleForSmbc ?
                    <MenuItem onClick={(event) => { handleClose(event,'APU');trackActivity('Item Clicked',{page_title:'Asset List', item_type:'Add APU', event_desc:'Clicked on APU from Add Asset in Asset listing page'})}}>APU</MenuItem>:null
                  }
                  { checkPermission('technical_specs', 'landing_gears','C') && !hideModuleForAvolon  && !hideModuleForSmbc ?
                    <MenuItem onClick={(event) => { handleClose(event,'Landing Gear');trackActivity('Item Clicked',{page_title:'Asset List', item_type:'Add Landing Gear', event_desc:'Clicked on Landing Gear from Add Asset in Asset listing page'})}}>Landing Gear</MenuItem>:null
                  }
                  { checkPermission('technical_specs', 'propeller','C') && !hideModuleForAvolon  && !hideModuleForSmbc ?
                    <MenuItem onClick={(event) => { handleClose(event,'Propeller');trackActivity('Item Clicked',{page_title:'Asset List', item_type:'Add Propeller', event_desc:'Clicked on Propeller from Add Asset in Asset listing page'})}}>Propeller</MenuItem>:null
                  }
                  
                 { getLocalStorageInfo()?.defaultLessor?.id !== 442 && !hideModuleForAvolon && !hideModuleForSmbc && checkPermission('technical_specs', 'engine','C') ?  <MenuItem onClick={(event) => { handleClose(event,'Engine Module');trackActivity('Item Clicked',{page_title:'Asset List', item_type:'Add Engine Module', event_desc:'Clicked on Engine Module from Add Asset in Asset listing page'})}}>Engine Module</MenuItem>:null}
                  
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  )
}

export default AssetAddDropdown;
